// redux/slices/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  permissions: [] // This will store the array of modules directly
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // 🟢 Update here
    setUserRoles(state, action) {
      // Expecting payload = response.modules (array)
      state.permissions = action.payload || [];
    },
    clearUser(state) {
      state.permissions = [];
    }
  }
});

export const { setUserRoles, clearUser } = authSlice.actions;
export default authSlice.reducer;